export default function (data) {
  if (data === undefined) return ' - '
  return data.clp
}
